import { _apiV2_get } from "@/app/api2"

// ########## Categories API ##########
export async function apiv2_getCategories() {
  return _apiV2_get("/categories", {
    key: "getCategories()",
    cacheLS: true,
  })
}

export async function apiv2_getCategory(categoryId: string) {
  return _apiV2_get(`/categories/${categoryId}`, {
    key: `getCategory(${categoryId})`,
    cacheLS: true,
  })
}

// ########## Industry API ##########
export async function apiv2_getIndustry() {
  return _apiV2_get("/industry", {
    key: "getIndustry()",
    cacheLS: true,
  })
}
